module.exports = __webpack_public_path__ + "static/media/icon-shown-assistance.44daf7cc.svg";